const messages = {
  en: {
    // == Shared ==
    shared: {
      titles: {
        home: 'Home',
        products: 'Products',
        projects: 'Projects',
        dealers: 'Dealers',
        company: 'Company',
        warranties: 'Warranties',
        contact: 'Contact',
        gallery: 'Gallery',
        cita:'Contact an advisor and schedule an appointment',
        video:'WATCH OUR VIDEO',
        list:'List',
        downloads: 'Downloads',
        providers: 'Providers',
      },


    },
    footer:{
        titles:{
            addresstitle:'Address',
            address1:'1250 East 6600 South Murray,',
            address2:'UT 84121',

            phone:'Phone',
            email:'Email',
            web:'Web',

            contact: 'Contact',
            dealers: 'Dealers',
            providers: 'Providers',
            downloads: 'Downloads',
            warranties: 'Warranties',
            privacy: 'Privacy Policy',
        }
    },
    // == ==

    // == Home page ==
    homePage: {
        banners:{
          title:'Design and manufacture of PVC windows and doors.'
        },
        modals:
        {
            main_title:'High quality and long service life.',

            title1:'Safety',
            txt1:'Hardness of profiles and hardware imported from Germany.',

            title2:'Thermal isolation',
            txt2:'Important savings in heating and air conditioning energy.',

            title3:'Acoustic isolation',
            txt3:'Real noise reduction.',

            title4:'Endurance',
            txt4:'PVC with great protection for any eventuality.',
        },
        titles:{
          articles:'Articles',
          products: 'Products',
          projects: 'Projects',
          providers: 'Providers',
        }
    },
    articles:{
        title:'YOU MAY ALSO LIKE',
    },
    productDetail:
    {
        titles:{
            characteristics:'Characteristics',
            finishes:'Finishes',
            video_gallery:'Video gallery',
            projectswprod:'Projects with this product',

        }
    },
    company:
    {
        titles:{
            mission:'MISSION',
            view:'VIEW',
        }
    },
    dealers:{
      titles:{
          buttonm:'See in Maps'
      }
    }
    // == ==

  },
  // == ==

  es: {
    // == Shared ==
    shared: {
      titles: {
        home: 'Inicio',
        products: 'Productos',
        projects: 'Proyectos',
        dealers: 'Distribuidores',
        company: 'Empresa',
        warranties: 'Garantias',
        contact: 'Contacto',
        gallery: 'Galería',
        cita:'Contacta un asesor y agenda una cita',
        video:'MIRA NUESTRO VIDEO',
        list:'Listado',
        downloads: 'Descargas',
        providers: 'Proveedores',
      },


    },
    footer:{
        titles:{
            addresstitle:'Dirección',
            address1:'1250 East 6600 South Murray,',
            address2:'UT 84121',
            phone:'Teléfono',
            email:'Correo Electrónico',
            web:'Web',

            contact: 'Contacto',
            dealers: 'Distribuidores',
            providers: 'Proveedores',
            downloads: 'Descargas',
            warranties: 'Garantias',
            privacy: 'Aviso de Privacidad',
        }
    },
    // == ==

    // == Home page ==
    homePage: {
        banners:{
          title:'Diseño y fabricación de puertas y ventanas de PVC.'
        },
        modals:
        {
            main_title:'De alta calidad y larga vida util.',

            title1:'Seguridad',
            txt1:'Dureza de perfiles y herrajes importados de Alemania.',

            title2:'Aislamiento Térmico',
            txt2:'Ahorro importantes de energia de calefacción y aire acondicionado.',

            title3:'Aislamiento Acústico',
            txt3:'Disminución de ruido real.',

            title4:'Resistencia',
            txt4:'PVC con gran protección para cualquier eventualidad.',

        },
        titles:{
          articles:'Artículos',
          projects: 'Proyectos',
          products: 'Productos',
          providers: 'Proveedores',
        },

    },
    // == ==
    articles:{
        title:'TÁMBIEN TE PUEDE INTERESAR',
    },
    productDetail:
    {
        titles:{
            characteristics:'Caracteristicas',
            finishes:'Acabados',
            video_gallery:'Galería de videos',
            projectswprod:'Proyectos con este producto',

        }
    },
    company:
    {
        titles:{
            mission:'MISION',
            view:'VISION',
        }
    },
    dealers:{
      titles:{
          buttonm:'Ver en Maps'
      }
    }


  }
}

export default messages;
